import React from 'react';
import { ListItem, Grid, Button, withStyles } from '@material-ui/core';
import { useTranslations } from 'adapters/i18n';
export const BotaoExibirDetalhesFarol = props => {
  const { classes, abrirDetalhes, exibirBotao, desabilitaBotao } = props;

  const { t } = useTranslations();

  return !exibirBotao ? null : (
    <ListItem key="BotaoDetalhes">
      <Grid container>
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Button
            disabled={desabilitaBotao}
            fullWidth
            variant="outlined"
            color="primary"
            onClick={abrirDetalhes}
            className={classes.buttonDetalhes}
          >
            {t("statusIndicator:details").toUpperCase()}
          </Button>
        </Grid>
      </Grid>
    </ListItem>
  );
};

const styles = {
  buttonDetalhes: {
    borderRadius: '18px',
    height: '36px'
  }
};
const botaoExibirDetalhesFarolMemoized = React.memo(BotaoExibirDetalhesFarol, (prevProps, nextProps) => {
  const exibirBotaoIguais = prevProps.exibirBotao === nextProps.exibirBotao;
  const desabilitaBotaoIguais = prevProps.desabilitaBotao === nextProps.desabilitaBotao;
  return exibirBotaoIguais && desabilitaBotaoIguais;
});
export default withStyles(styles)(botaoExibirDetalhesFarolMemoized);
